import React from 'react';
import './PC.css';
import aws from '../../img/pc/aws.png'
import Barthwal from '../../img/pc/Barthwal.png'
import booking from '../../img/pc/booking.png'
import calendly from '../../img/pc/calendly.png'
import Chen from '../../img/pc/Chen.png'
import Chestnut from '../../img/pc/Chestnut.png'
import Chopra from '../../img/pc/Chopra.png'
import ebay from '../../img/pc/ebay.png'
import facebook from '../../img/pc/facebook.png'
import Gordiienko from '../../img/pc/Gordiienko.png'
import Liu from '../../img/pc/Liu.png'
import Mezzalira from '../../img/pc/Mezzalira.png'
import microsoft from '../../img/pc/microsoft.png'
import nasa from '../../img/pc/nasa.png'
import Polat from '../../img/pc/Polat.png'
import Rasmussen from '../../img/pc/Rasmussen.png'
import Ritchson from '../../img/pc/Ritchson.png'
import samsung from '../../img/pc/samsung.png'
import Adobe from '../../img/pc/Adobe.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Chen,
          name: 'Fong Tuan Chen',
          position: 'Country HR & General Affairs Director',
          ln: 'https://www.linkedin.com/in/fongtuanchen/',
          logo: samsung,
        },
        {
          photo: Chopra,
          name: 'Nidhi Chopra',
          position: 'Sr. HR Business Partner',
          ln: 'https://www.linkedin.com/in/nidhi-chopra-sydney/',
          logo: Adobe,
        },
        {
          photo: Rasmussen,
          name: 'Louise Rasmussen',
          position: 'QA Manager',
          ln: 'https://www.linkedin.com/in/louisethyrringrasmussen/',
          logo: ebay,
        },
        {
          photo: Gordiienko,
          name: 'Dmytro Gordiienko',
          position: 'Senior QA Engineer',
          ln: 'https://www.linkedin.com/in/dmytrogordiienko/',
          logo: facebook,
        },
        {
          photo: Liu,
          name: 'Flint Liu',
          position: 'Lead QA Automation',
          ln: 'https://www.linkedin.com/in/yang-liu-470b4b60/',
          logo: booking,
        },
        // {
        //   photo: Chestnut,
        //   name: 'Erika Chestnut',
        //   position: 'Head of QA',
        //   ln: 'https://www.linkedin.com/in/erikachestnut',
        //   tw: 'https://twitter.com/erika_chestnut',
        //   logo: calendly,
        // },
        {
          photo: Polat,
          name: 'Engin Polat',
          position: 'Senior Software Engineer',
          ln: 'https://linkedin.com/in/polatengin',
          logo: microsoft,
        },
        {
          photo: Mezzalira,
          name: 'Luca Mezzalira',
          position: 'Principal Solutions Architect',
          ln: 'https://www.linkedin.com/in/lucamezzalira/',
          tw: 'https://twitter.com/lucamezzalira',
          logo: aws,
        },
        {
          photo: Ritchson,
          name: 'Michael Ritchson',
          position: 'Enterprise Solutions Architect',
          ln: 'https://www.linkedin.com/in/michael-ritchson-0ab40119a/',
          logo: nasa,
        },
        // {
        //   photo: Barthwal,
        //   name: 'Nikhil Barthwal',
        //   position: 'Sr. Software Engineer',
        //   tw: 'https://twitter.com/nikhilbarthwal',
        //   website: 'http://www.nikhilbarthwal.com',
        //   logo: facebook,
        // },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}